import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    let lastScrollTop = 0;

    const handleScroll = () => {
      const header = document.querySelector(".core-navbar");
      const slidebar = document.querySelector(".filter-sidebar-node");

  
      if (!header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

     
      if (scrollTop <= 0) {
        header.style.top = "0px";
        if (slidebar) {
          slidebar.style.top = "155px";
        }
        lastScrollTop = 0;
        return;
      }

     
      if (scrollTop > lastScrollTop) {
        header.style.top = "-120px";
           header.style.position = "fixed";
        if (slidebar) {
          slidebar.style.top = "10px";
        }
      } else {
      
        header.style.top = "0px";
           
              if (150 < scrollTop) {
    header.style.position = "fixed";
 }else{
    header.style.position = "sticky";
 }
        if (slidebar) {
          slidebar.style.top = "80px";
          slidebar.style.height = "calc(100vh - 85px)";
        }
      }
   
      lastScrollTop = scrollTop;
   
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); 

  return null;
}